import { render } from "./VxBlog.vue?vue&type=template&id=13d7ea71&scoped=true"
import script from "./VxBlog.vue?vue&type=script&lang=js"
export * from "./VxBlog.vue?vue&type=script&lang=js"

import "./VxBlog.vue?vue&type=style&index=0&id=13d7ea71&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d7ea71"]])

export default __exports__